// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"RI-z","smallCardRow":"SI-z","largeCardRow":"TI-z","productSearchRow":"UI-z","curatedRow":"VI-z"};